import React, { Dispatch, isValidElement, SetStateAction } from 'react';
import { DragHandle } from './drag-handle';
import { DataTableColumn, DataTableRow } from './data-table';
import { Checkbox } from '../checkbox/checkbox';
import { Typography } from '../typography/typography';
import classNames from 'classnames';

export const StaticTableRow = ({
  row,
  idx,
  columnNames,
  selectedItems,
  setSelectedItems,
}: {
  row: DataTableRow | null;
  idx: number | undefined;
  columnNames: DataTableColumn[];
  selectedItems: Array<number>;
  setSelectedItems: Dispatch<SetStateAction<number[]>>;
}) => {
  return (
    <tr>
      {columnNames.map(
        ({ key, fixedAsFirst, fixedAsLast, isCheckBoxColumn, hide = false, showRule = 'Both', className }) => {
          const tdContent = (
            <>
              {isCheckBoxColumn && (
                <Checkbox
                  type="white"
                  isChecked={idx ? selectedItems.includes(idx) : false}
                  onChange={(isChecked) => {
                    if (idx) {
                      if (isChecked) {
                        setSelectedItems((prevState: number[]) => [...prevState, idx]);
                      } else {
                        setSelectedItems((prevState: number[]) => prevState.filter((elem: number) => elem !== idx));
                      }
                    }
                  }}
                />
              )}
              {row && isValidElement(row.fields[key]) ? (
                row.fields[key]
              ) : (
                <Typography type="text-sm" className="text-quipli-black-800">
                  {row && row.fields[key]}
                </Typography>
              )}
            </>
          );

          const td = !hide && showRule !== 'OnlyMobile' && (
            <td
              key={`td-${key}-${key}`}
              className={classNames(key, className, {
                hasCheckBox: isCheckBoxColumn,
                'sticky-col-first': fixedAsFirst,
                'sticky-col-last': fixedAsLast,
              })}
            >
              {key == 'sort' ? <DragHandle isDragging /> : tdContent}
            </td>
          );

          return td;
        },
      )}
    </tr>
  );
};
